import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import SuperAdminIcon from './SuperAdminIcon';
import { superAdminNavigation } from './superAdminNavigation';

const SuperAdminSidebar = ({ collapsed, mobileOpen, onCloseMobile, onToggleCollapsed }) => {
  const [expandedGroups, setExpandedGroups] = useState(() => Object.fromEntries(
    superAdminNavigation.map((group) => [group.label, true])
  ));

  const toggleGroup = (label) => {
    setExpandedGroups((current) => ({ ...current, [label]: !current[label] }));
  };

  return (
  <aside
    aria-label="Super Admin navigation"
    className={`sa-sidebar${collapsed ? ' is-collapsed' : ''}${mobileOpen ? ' is-mobile-open' : ''}`}
  >
    <div className="sa-sidebar__brand">
      <span className="sa-sidebar__mark" aria-hidden="true"><img src="/favicon.png" alt="" /></span>
      <span className="sa-sidebar__brand-copy">
        <strong>CrickArena</strong>
        <small>Super Admin</small>
      </span>
      <button className="sa-icon-button sa-sidebar__mobile-close" type="button" onClick={onCloseMobile} aria-label="Close navigation">
        <SuperAdminIcon name="close" />
      </button>
    </div>

    <nav className="sa-sidebar__nav">
      {superAdminNavigation.map((group) => (
        <section className="sa-nav-group" key={group.label} aria-labelledby={`sa-nav-${group.label.replaceAll(' ', '-').toLowerCase()}`}>
          <h2 id={`sa-nav-${group.label.replaceAll(' ', '-').toLowerCase()}`}>
            <button type="button" onClick={() => toggleGroup(group.label)} aria-expanded={expandedGroups[group.label]}>
              <span>{group.label}</span>
              <span aria-hidden="true" className="sa-nav-group__chevron">⌄</span>
            </button>
          </h2>
          <div className="sa-nav-group__items" hidden={!expandedGroups[group.label] && !collapsed}>
            {group.items.map((item) => (
              <NavLink
                className={({ isActive }) => `sa-nav-link${isActive ? ' is-active' : ''}`}
                end={!['/sa/organizations', '/sa/communities', '/sa/clubs', '/sa/grounds'].includes(item.to)}
                key={item.to}
                onClick={onCloseMobile}
                aria-label={collapsed ? item.label : undefined}
                data-tooltip={collapsed ? item.label : undefined}
                to={item.to}
              >
                <SuperAdminIcon name={item.icon} />
                <span>{item.label}</span>
              </NavLink>
            ))}
          </div>
        </section>
      ))}
    </nav>

    <button
      className="sa-sidebar__collapse"
      type="button"
      onClick={onToggleCollapsed}
      aria-expanded={!collapsed}
      aria-label={collapsed ? 'Expand navigation' : 'Collapse navigation'}
    >
      <SuperAdminIcon name="collapse" />
      <span>Collapse</span>
    </button>
  </aside>
  );
};

export default SuperAdminSidebar;
